import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import "./assets/scss/theme.scss";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import HelloWorld from "./components/HomePage.vue";
import VueRouter from "vue-router";

Vue.config.productionTip = false;

Vue.use(VueRouter);
const routes = [{ path: "*", component: HelloWorld }];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

Vue.use(
  VueGtag,
  {
    config: {
      id: "UA-154935159-2", // google analytics
      additionalAccounts: [
        {
          id: "AW-603843266"
        }
      ]
    }
  },
  router
);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
